import { useThemeStore } from '../stores/themeStore';

/**
 * Convenience hook for theme management.
 * Returns the current dark mode state and a toggle function.
 */
export function useTheme() {
  const isDark = useThemeStore((s) => s.isDark);
  const toggle = useThemeStore((s) => s.toggle);
  return { isDark, toggle } as const;
}
